import React from 'react';
import s from './ConstituencyCandidate.scss';
import { IMAGE_URL } from '../../../constants';
import Link from '../../../components/Link/Link';
import { createSlug } from '../../../utils/common';

const csValueMapping = {
  3: {
    name: 'Won',
    state: 'won',
  },
  1: {
    name: 'leading',
    state: 'leading',
  },
  2: {
    name: 'Trailing',
    state: 'trailing',
  },
  4: {
    name: `1st Runner Up `,
    state: 'lost',
  },
};

const csValueMapping2 = {
  3: {
    name: 'Won',
    state: 'won',
  },
  1: {
    name: 'leading',
    state: 'leading',
  },
};

const ConstituencyCandidate = ({
  candidate: {
    cc,
    lg,
    cn,
    cs,
    an,
    tc,
    pr,
    seonm = '',
    c_id = '',
    cns_name = '',
    sn = '',
  },
  isWapView,
  index,
  vm,
  candidateLinking = false,
}) => (
  <div className={`${s.candidateSpWrap} ${s[csValueMapping[cs]?.state]}`}>
    <div className={s.candidateSpInfo}>
      <span className={s.SppartyLogo}>
        <img src={`${IMAGE_URL}${lg}.cms`} alt="Party Logo" />
      </span>
      <div className={s.namePartyStatusWrap}>
        {candidateLinking &&
        sn &&
        cns_name &&
        seonm &&
        cns_name &&
        seonm !== 'nota' &&
        c_id ? (
          <Link
            to={`/elections/lok-sabha-elections/${createSlug(sn)}/${createSlug(
              cns_name,
            )}/candidateshow/${seonm}-${c_id}`}
            target="_blank"
          >
            <div className={s.cSpName}>{cn}</div>
          </Link>
        ) : (
          <div className={s.cSpName}>{cn}</div>
        )}
        <span className={`${s.partyStatus}`}>
          <span style={{ color: cc }}>{an}</span>
          {!!(vm && index < 2 && csValueMapping[cs]?.name) &&
            ` - ${csValueMapping[cs]?.name}`}
          {!vm &&
            csValueMapping2[cs]?.name &&
            ` - ${csValueMapping2[cs]?.name}`}
        </span>
      </div>
    </div>
    {(cs === 3 || cs === 4) &&
      !!vm && (
        <div className={s.votingInfo}>
          <div className={`${s.votes}`}>
            <span className={s.label}>Votes</span>
            <span className={s.labelInfo}>
              <strong>{tc.toLocaleString()}</strong>
            </span>
          </div>
          <div className={`${s.votes}`}>
            {!isWapView && <span className={s.label}>Vote %</span>}
            <span className={s.labelInfo}>
              <strong>{pr}</strong> {isWapView && '%'}
            </span>
          </div>
        </div>
      )}
  </div>
);

export default ConstituencyCandidate;
